import React from "react";
import { Select } from "antd";
import services from "../../../services";
import { Button } from "@progress/kendo-react-buttons";
import moment from "moment";
import { toast } from "react-toastify";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { Input } from "@progress/kendo-react-inputs";
import $ from 'jquery'
const { Option } = Select;

const userKeys = [
    "numeroRegisto"
];

class RegistoListModalForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataContent: this.props.data,
            contentInfo: {}
        };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {

        // let data = this.props.data;


        // this.setState({
        //     data
        // });
        // this.fillData(data);
        console.log('MODAL REGISTO MONTADO: ', this.state.dataContent);

        this.handleData();
    }

    handleData() {
        let correlativaRotulos = '';
        let mencoesComplementares = '';
        let DadosSensoriais = '';
        let DadosAnaliticos = '';
        let contentInfo = {};

        const objectCorrelativaProdutos = this.state.dataContent.res.correlativaRotulos;
        const objectMencoesComplementares = this.state.dataContent.res.mencoesComplementares;
        console.log(objectMencoesComplementares, "são as meções obj")

        var mencoesQuinta;
        var mencoesCasta;
        var outrasMencoes ;

        var mencoesDesignacao = [];

        for (let index = 0; index < objectMencoesComplementares.mencoesQuinta.length; index++) {
            mencoesQuinta = objectMencoesComplementares.mencoesQuinta[index].designacao;
            //mencoesDesignacao.push({"text": mencoesQuinta})
            mencoesComplementares += mencoesQuinta
        }
        for (let index = 0; index < objectMencoesComplementares.mencoesCasta.length; index++) {
            mencoesCasta = objectMencoesComplementares.mencoesCasta[index].designacao;  
           // mencoesDesignacao.push({"text": mencoesCasta})
           mencoesComplementares += mencoesCasta
        }
        for (let index = 0; index < objectMencoesComplementares.outrasMencoes.length; index++) {
            outrasMencoes = objectMencoesComplementares.outrasMencoes[index].mencaoComplementar;
            //mencoesDesignacao.push({"text": outrasMencoes})
            mencoesComplementares += outrasMencoes
        }
        console.log(mencoesDesignacao);
        objectCorrelativaProdutos.map((element, index) => {
            if(element.correlativaRotulo != ""){
                if (index + 1 === objectCorrelativaProdutos.length) { 
                    correlativaRotulos += '<span class="correlativaElementos">'+element.correlativaRotulo+'</span>';
                } else {
                    correlativaRotulos += '<span class="correlativaElementos">'+element.correlativaRotulo+'</span>';
                }     
            }
            
        }
        );

        console.log(objectMencoesComplementares , "isto são as menções")

        contentInfo.correlativaRotulos = correlativaRotulos;
        if(correlativaRotulos == ""){
            var correlativaDados = '<div>Sem dados a apresentar</div>'
        }else{
            var correlativaDados = '<div class ="rowCorrelativas">'+ correlativaRotulos+'</div>'
        }
            

        $(".correlativasDados").html(correlativaDados)
        contentInfo.mencoesComplementares = mencoesComplementares;
        contentInfo.DadosSensoriais = DadosSensoriais;
        contentInfo.DadosAnaliticos = DadosAnaliticos;
        console.log(contentInfo, 'CONTENT INFODOSMOAM');
        this.setState({
            contentInfo
        });
    }
    defaultLoader = () => { };

    
    
    componentDidUpdate(prevProps) {
        if (prevProps.date !== this.props.date) {
            let data = this.props.data;

            data.then((value) => {
                this.setState({
                    dataContent: value
                });
            });

            this.handleData();
        }
    }

    handleFechar = () => {
        let dataContent = {};
        let contentInfo = {};
        this.setState({
            dataContent,
            contentInfo
        });

        this.props.closePopup();
    };


    render() {
        return (
            <>
                <div className="modal-content modal-registo" >
                    <div className="modal-header">
                        <h1 className="modal-title pl-0  theme-color titulo-modal-registo">
                            Detalhes do registo {this.state.dataContent.numeroRegisto}
                        </h1>
                        {/* <button type="button" className="btn btn-success btn-sm text-uppercase mr-3">Guardar</button>  */}
                        <Button
                            onClick={() => this.handleFechar()}
                            primary={true}
                            className="remoove btn-ivdp-primary cursor-pointer mr-2 fecharbutton"
                            
                        >
                            Fechar
                        </Button>
                    </div>
                    <div className="modal-body" >
                        {this.state.contentInfo &&
                        <div className="tab-section">
                            <div className="row">
                                <div className="innerBox col-md-12 mb-2">
                                    <p className="theme-color label-registo">Correlativa rótulos</p>
                                    <h5 className="dados-modal-registo correlativasDados" ></h5>
                                </div>
                                <div className="innerBox col-md-12 mb-2">
                                    <p className="theme-color label-registo">Menções complementares</p>
                                    <h5 className="dados-modal-registo">{this.state.contentInfo.mencoesComplementares === ''? 'Sem dados a apresentar' : this.state.contentInfo.mencoesComplementares}</h5>
                                </div>
                                <div className="innerBox col-md-12 mb-2">
                                    <p className="theme-color label-registo">Dados Sensoriais</p>
                                    <h5 className="dados-modal-registo">{this.state.contentInfo.DadosSensoriais === ''? 'Sem dados a apresentar' : this.state.contentInfo.DadosSensoriais}</h5>
                                </div>
                                <div className="innerBox col-md-12 mb-2">
                                    <p className="theme-color label-registo">Dados Analíticos</p>
                                    <h5 className="dados-modal-registo">{this.state.contentInfo.DadosAnaliticos === ''? 'Sem dados a apresentar' : this.state.contentInfo.DadosAnaliticos}</h5>
                                </div>
                            </div>
                        </div>
                        }

                    </div>
                </div>
            </>
        )
    }
}

export default RegistoListModalForm;
